<template>
  <div>
    <b-alert
      :show="
        this.OpdAnestheticNoteDataInD &&
          this.OpdAnestheticNoteDataInD.length > 0
      "
      variant="dark"
      class="margin-bottom font12px"
    >
      <h6>Anesthetic Note {{ this.vnChang }}</h6>

      <b-row class="margin-bottom">
        <b-col lg="12" v-if="this.OpdAnestheticNoteData">
          <b-list-group>
            <b-list-group-item style="color:#111111;">
              <div
                v-html="OpdAnestheticNoteTextData"
                class="opd-er-anesthetic-note-text"
              ></div>

              <div
                class="log-style"
                v-if="OpdAnestheticNoteData && OpdAnestheticNoteData.datas"
              >
                Log.
                {{ OpdAnestheticNoteData.datas.insert_fullname || "" }}
                |
                {{
                  OpdAnestheticNoteData.datas.insert_datetime
                    ? thaiDatetimeFc.ThaiDateTime(
                        OpdAnestheticNoteData.datas.insert_datetime
                      )
                    : ""
                }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row class="margin-bottom">
        <b-col lg="12">
          <b-list-group>
            <b-list-group-item
              v-for="item in this.OpdAnestheticNoteDataInD"
              v-bind:key="item.id"
              style="color:#111111;"
            >
              <div
                v-html="item.datas.opd_anesthetic_note_text"
                class="opd-er-anesthetic-note-text"
              ></div>

              <div
                class="log-style"
                v-if="
                  item.datas.opd_anesthetic_note_user &&
                    item.datas.opd_anesthetic_note_datetime
                "
              >
                Log.
                {{ item.datas.opd_anesthetic_note_user || "" }}
                |
                {{
                  item.datas.opd_anesthetic_note_datetime
                    ? thaiDatetimeFc.ThaiDateTime(
                        item.datas.opd_anesthetic_note_datetime
                      )
                    : ""
                }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row v-if="this.$store.get('systems@LoginData')">
        <b-col lg="6" class="margin-bottom">
          <b-button
            v-show="false"
            variant="primary"
            size="sm"
            class="d-print-none"
            v-b-modal.bv-modal-anesthetic-note
            >บันทึก Anesthetic Note</b-button
          >
        </b-col>
      </b-row>
    </b-alert>

    <div>
      <div v-if="this.$store.get('systems@LoginData')">
        <b-modal
          id="bv-modal-anesthetic-note"
          hide-footer
          size="xl"
          :no-close-on-backdrop="true"
          :close-on-esc="true"
        >
          <template slot="modal-title">
            Anesthetic Note
          </template>

          <div class="d-block text-left margin-bottom" style="color:#000000;">
            <ckeditor
              :editor="editor"
              v-model="UserOPDNoteDatavalue"
              :config="editorConfig"
            ></ckeditor>
          </div>

          <div class="d-block text-center">
            <b-button
              variant="success"
              size="sm"
              class="d-print-none"
              @click="SubmitOpdAnestheticNote('add')"
              >บันทึก</b-button
            >
            &nbsp;
            <b-button
              size="sm"
              class="d-print-none"
              @click="$bvModal.hide('bv-modal-anesthetic-note')"
              >ยกเลิก</b-button
            >
            &nbsp;
            <b-button
              variant="danger"
              size="sm"
              class="float-right d-print-none"
              @click="DeleteAnestheticNoteMsgBox('Delete')"
              v-if="this.OpdAnestheticNoteDataInD"
              >ลบ</b-button
            >
          </div>
        </b-modal>
      </div>
    </div>

    <!-- CSS animation example -->
    <notifications
      group="ansn-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="ansn-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="ansn-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import pjFunctions from "@/functions/pjFunctions";
import thaiDatetime from "@/functions/thaiDatetime";
import PatientOpdAnestheticNote from "@/models/patientEMRs/PatientOpdAnestheticNote";
import feather from "vue-icon";
import { Component, Vue } from "vue-property-decorator";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      time1: "",
      value12: "",
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค",
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days",
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range",
        },
      },
      indicators_data1_status: false,
      indicators_data2_status: false,
      indicators_data3_status: false,
      indicators_data4_status: false,
      indicators_data5_status: false,
      indicators_date1: "",
      indicators_date2: "",
      indicators_date3: "",
      indicators_date4: "",
      indicators_date5: "",
      indicators_time1: "",
      indicators_time2: "",
      indicators_time3: "",
      indicators_time4: "",
      indicators_time5: "",
      EmrTemplateData: null,
      EmrTemplateSelected: null,
      status: false,
      vnStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      OpdAnestheticNoteDataInD: null,
      OpdAnestheticNoteData: null,
      OpdAnestheticNoteTextData: null,
      apiCk: 0,
      ptHN: "",
      ptVN: "",
      conF: "",
      UserDT: null,
      OpdAnestheticNoteCh: "",
      UserOPDNoteData: "",
      UserOPDNoteFullData: null,
      UserOPDNoteDatavalue: "",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Font,
          Highlight,
          Alignment,
        ],

        minHeight: "300px",

        fontSize: {
          options: ["default", 9, 11, 13, 15, 17, 19, 21, 23, 25, 27],
        },

        toolbar: {
          items: [
            // 'fontFamily',
            "bold",
            "italic",
            "|",
            "fontSize",
            "fontColor",
            "highlight",
            "alignment",
            "|",
            "undo",
            "redo",
          ],
        },
      },
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientOpdAnestheticNote,
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
  },
  watch: {
    ptHN: function() {
      // this.setOpdAnestheticNote(this.ptVN,this.ptHN)
    },
    ptVN: function() {
      this.setOpdAnestheticNote(this.ptVN, this.ptHN);
      this.getUserOPDNote(this.ptVN, this.ptHN);
    },
    OpdAnestheticNoteCh: function() {
      this.getOpdAnestheticNote(this.ptVN, this.ptHN);
      this.getUserOPDNote(this.ptVN, this.ptHN);
    },
    UserDT: function() {
      this.getOpdAnestheticNote(this.ptVN, this.ptHN);
      this.getUserOPDNote(this.ptVN, this.ptHN);
    },
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.UserDT = this.$store.get("systems@LoginData");
    },
  },
  methods: {
    SubmitAddTemplate() {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะ Add Template ใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.conF = value;
          if (this.conF == true) {
            let ScrObj = PatientEmrTemplate.query()
              .where("id", this.EmrTemplateSelected)
              .get();

            if (ScrObj.length > 0) {
              this.OpdAnestheticNoteTextData =
                ScrObj[0].datas.emr_template_data;
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    DeleteAnestheticNoteMsgBox(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะลบข้อมูลใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.conF = value;
          if (this.conF == true) {
            this.SubmitOpdAnestheticNote(std);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random(),
        },
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    SubmitOpdAnestheticNote(std) {
      if (
        this.ptVN != "" &&
        this.ptHN != "" &&
        this.UserOPDNoteDatavalue != ""
      ) {
        let NoteText = "";

        if (std == "Delete") {
          NoteText = "-";
        } else {
          NoteText = this.UserOPDNoteDatavalue;
        }

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdAnestheticNoteAdd", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: ScrObj.ptHN,
            vn: ScrObj.ptVN,
            opd_anesthetic_note_text: NoteText,
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              ScrObj.setOpdAnestheticNote(ScrObj.ptVN, ScrObj.ptHN);

              ScrObj.show(
                "ansn-foo-css",
                "success",
                "Save Data Success",
                "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              ScrObj.$bvModal.hide("bv-modal-anesthetic-note");
            } else {
              ScrObj.show(
                "ansn-foo-css",
                "warn",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.show(
              "ansn-foo-css",
              "error",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("OpdAnestheticNoteAdd : " + ScrObj.output);
          });
      }
    },
    OpdAnestheticNoteReplace(txt) {
      String.prototype.replaceAll = function(search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
      };
      let PgNote = txt;
      PgNote = PgNote.replaceAll("<br />", "\n");
      PgNote = PgNote.replaceAll("<br>", "\n");
      PgNote = PgNote.replaceAll("<br >", "\n");
      return PgNote;
    },
    setOpdAnestheticNote(vn, hn) {
      this.OpdAnestheticNoteCh = "OpdAnestheticNote" + vn;

      let CkScrObj = PatientOpdAnestheticNote.query()
        .where("hn", hn)
        .where("vn", vn)
        .get();

      if (vn != "" && vn != null && CkScrObj.length >= 0) {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdAnestheticNote", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn,
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientOpdAnestheticNote.delete({
                where(record) {
                  return record.vn == vn;
                },
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.vn + val.loginname,
                  loginname: val.loginname,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val,
                });
              }

              PatientOpdAnestheticNote.insertOrUpdate({
                data,
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientOpdAnestheticNote.delete({
                  where(record) {
                    return record.vn == vn;
                  },
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("OpdAnestheticNote : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.OpdAnestheticNoteCh = "OpdAnestheticNote" + vn;
            ScrObj.getOpdAnestheticNote(vn, hn);
            ScrObj.getUserOPDNote(vn, hn);
          });
      }
    },
    getOpdAnestheticNote(vn, hn) {
      let ScrObj = PatientOpdAnestheticNote.query()
        .where((record) => record.datas.hn == hn)
        .where((record) => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.OpdAnestheticNoteDataInD = ScrObj;
        this.apiCk = this.apiCk + 1;
      } else {
        this.OpdAnestheticNoteDataInD = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    getUserOPDNote(vn, hn) {
      if (this.$store.get("systems@LoginData")) {
        let ScrObj = PatientOpdAnestheticNote.query()
          .where((record) => record.datas.hn == hn)
          .where((record) => record.datas.vn == vn)
          .where(
            (record) =>
              record.datas.loginname ==
              this.$store.get("systems@LoginData").UserId
          )
          .get();

        if (ScrObj.length > 0) {
          this.UserOPDNoteFullData = ScrObj[0];
          this.UserOPDNoteData = ScrObj[0].datas.opd_anesthetic_note_text;

          this.UserOPDNoteDatavalue = this.UserOPDNoteData;

          this.apiCk = this.apiCk + 1;
        } else {
          this.UserOPDNoteFullData = null;
          this.UserOPDNoteData = "";

          this.UserOPDNoteDatavalue = " ";
        }
      } else {
        this.UserOPDNoteFullData = null;
        this.UserOPDNoteData = "";

        this.UserOPDNoteDatavalue = " ";
      }
    },
  },
})
export default class EmrOpdAnestheticNote extends Vue {}
</script>

<style lang="scss">
.ck {
  p {
    margin: 0;
  }
}

.opd-er-anesthetic-note-text {
  p {
    margin: 0;
  }
}

.ck-editor__editable {
  min-height: 200px;
}
</style>
